import { render, staticRenderFns } from "@/style-guide/partials/spotlightText/spotlightText.pug?vue&type=template&id=609e17f0&scoped=true&lang=pug&external"
import script from "./spotlightText.vue?vue&type=script&lang=ts"
export * from "./spotlightText.vue?vue&type=script&lang=ts"
import style0 from "./spotlightText.vue?vue&type=style&index=0&id=609e17f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e17f0",
  null
  
)

export default component.exports